/**
 * Constantes compartidas para QR Previews
 */

// Endpoints for external validations
export const VALIDATION_ENDPOINTS = {
  YOUTUBE_OEMBED: "https://www.youtube.com/oembed?url={url}",
  VIMEO_OEMBED: "https://vimeo.com/api/oembed.json?url={url}",
} as const;

// Predefined image variants
export const IMAGE_VARIANTS = {
  "logo-large": ["w_400,h_400,q_90,f_auto,c_fill"],
  avatar: ["w_100,h_100,q_90,f_auto,c_fill"],
  thumbnail: ["w_200,h_200,q_90,f_auto,c_fill"],
  hero: ["f_auto,q_auto,w_1280,h_640,dpr_auto,c_fill"],
} as const;

// Configurations by social network variant
export const SOCIAL_NETWORK_VARIANTS = {
  business: { center: true, compact: false },
  coupon: { center: true, compact: true },
  links: { center: false, compact: false },
  website: { center: true, compact: false },
} as const;

// Retry configurations for images
export const IMAGE_RETRY_CONFIG = {
  maxRetries: 2,
  baseDelay: 1000, // 1 second
} as const;
